import alertify from 'alertify.js';

export const NOTIFY_TYPE = {
    ALERT: 'alert',
    CONFIRM: 'confirm',
    ERROR: 'error',
    LOG: 'log',
    PROMPT: prompt,
    SUCCESS: 'success',
};

export const STATUS_CODE = {
    ERROR: 500,
    FORBIDDEN: 403,
    UNAUTHORIZED: 401,
    BAD_REQUEST: 400,
    SUCCESS: 200
};

const STATUS_MESSAGE = {
    [STATUS_CODE.SUCCESS]: {
        type: NOTIFY_TYPE.SUCCESS,
        text: 'Operação Realizada com Sucesso'
    },
    [STATUS_CODE.FORBIDDEN]: {
        type: NOTIFY_TYPE.ERROR,
        text: 'Sem permissão para visualizar essa área'
    },
    [STATUS_CODE.ERROR]: {
        type: NOTIFY_TYPE.ERROR,
        text: 'Ocorreu um erro, por favor contate o administrador do sistema'
    },
    [STATUS_CODE.BAD_REQUEST]: {
        type: NOTIFY_TYPE.LOG,
        text: 'Sem permissão de acesso'
    }
};

export class Notify {
    constructor (type, text) {
        this.text = text;
        this.type = type;

        this.show();
    }

    show () {
        if (!this.text) {
            return;
        }

        return alertify
            .reset()
            .maxLogItems(3)
            .logPosition('bottom center')
            .delay(5000)[this.type](this._insertText());
    }

    _insertText () {
        const layout = {
            [NOTIFY_TYPE.SUCCESS]: () => `<i class="fa fa-check"></i>&nbsp;&nbsp;&nbsp;${this.text}`,
            [NOTIFY_TYPE.LOG]: () => this.text,
            [NOTIFY_TYPE.ERROR]: () => `<i class="fa fa-frown-o"></i>&nbsp;&nbsp;&nbsp;${this.text}`,
            [NOTIFY_TYPE.ALERT]: () => `<i class="fa fa-frown-o"></i>&nbsp;&nbsp;&nbsp;${this.text}`,
        };
        return layout[this.type]();
    }
}

export class NotifyError extends Notify {
    constructor (xhr, msg = {}) {
        const status = STATUS_MESSAGE[xhr && xhr.status] || STATUS_MESSAGE[STATUS_CODE.ERROR];
        super((msg.type || status.type), (msg.text || status.text));
    }
}

export class NotifySuccess extends Notify {
    constructor (msg = {}) {
        const status = STATUS_MESSAGE[200];
        super((msg.type || status.type), (msg.text || status.text));
    }
}

export const notify = (type, text) => new Notify(type, text);
export const notifyError = (xhr, msg) => new NotifyError(xhr, msg);
export const notifySuccess = (msg) => new NotifySuccess(msg);



// WEBPACK FOOTER //
// ./src/scripts/shared/notify.js